import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-large);
	padding: var(--accordion-padding-v) var(--accordion-padding-h);
`;
